<div class="section-account bg-white p-t-0">
  <div class=" d-flex p-4">
    {{isMobileDevice}}
  </div>
</div>

